export const MARKET_TIMELINE_EVENT_TYPES = [
  "LISTED",
  "MARKET_STATS_CAPTURED",
  "PRICE_CHANGED",
  "FIRST_CALL",
  "FIRST_VIEWING",
  "VIEWING",
  "BUYER_OFFER",
  "RESERVED",
  "FINANCING_APPROVED",
  "CONTRACT_SIGNED",
  "SOLD",
  "CUSTOM",
  "MARKET_REPORT_CREATED",
  "MARKET_POSITION_CHANGED",
  "LISTING_REFRESHED",
  "LISTING_PAUSED"
] as const;

export type MarketTimelineEventType = (typeof MARKET_TIMELINE_EVENT_TYPES)[number];
export type MarketTimelineEventSource = "case_workflow" | "crm" | "manual" | "portal" | "market";
export type MarketStatsSource = "nehutelnosti_sk" | "bazos_sk" | "manual" | "api" | "screenshot" | "other";
export type MarketDataOrigin = "PORTAL_DATA" | "CRM_DATA" | "MARKET_DATA" | "MANUAL_DATA";
export type MarketStatsField = "views" | "detailViews" | "calls" | "emails" | "saved" | "viewings";

export type MarketTimelineMetadata = {
  askingPrice?: number;
  oldPrice?: number;
  newPrice?: number;
  realizedPrice?: number;
  count?: number;
  statsSnapshotId?: string;
  sourceLabel?: string;
};

export type MarketTimelineEvent = {
  id: string;
  caseId: string;
  type: MarketTimelineEventType;
  occurredAt: string;
  title: string;
  description?: string;
  source: MarketTimelineEventSource;
  metadata?: MarketTimelineMetadata;
  createdAt: string;
};

export type MarketStatsScreenshotReference = {
  fileName: string;
  mimeType: string;
  size: number;
};

export type MarketStatsSnapshot = {
  id: string;
  caseId: string;
  capturedAt: string;
  dayFromListing: number;
  source: MarketStatsSource;
  origin: MarketDataOrigin;
  views?: number;
  detailViews?: number;
  calls?: number;
  emails?: number;
  saved?: number;
  viewings?: number;
  fieldSources: Partial<Record<MarketStatsField, MarketStatsSource>>;
  askingPriceAtCapture?: number;
  notes?: string;
  screenshot?: MarketStatsScreenshotReference;
  createdAt: string;
};

export type MarketTimelineState = {
  schemaVersion: "market-timeline-1";
  events: MarketTimelineEvent[];
  statsSnapshots: MarketStatsSnapshot[];
};

export type MarketStatsInput = Partial<Record<MarketStatsField, number>> & {
  capturedAt: string;
  source: MarketStatsSource;
  notes?: string;
  screenshot?: MarketStatsScreenshotReference;
};

export type MarketResponseStatus = "LOW_RESPONSE" | "NORMAL_RESPONSE" | "STRONG_RESPONSE" | "INSUFFICIENT_DATA";

export type MarketResponseBenchmark = {
  source: string;
  sampleSize: number;
  dayFromListing: number;
  averageCalls: number;
  averageViewings: number;
  averageDetailViewRatio?: number;
};
